import React from 'react';
import { Link } from 'react-router-dom';

const Pricing: React.FC = () => {
  return (
    <section id="pricing" className="pricing-section w-full px-6 md:px-12 lg:px-20 py-16 md:py-24">
      <div className="max-w-4xl mx-auto text-center">
        {/* Discount Badge */}
        <div className="inline-block bg-blue-500 text-white px-6 py-2 rounded-md font-bold text-lg mb-6 shadow-lg">
          70% OFF!
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Get AdSmash 70% Off
        </h2>
        <p className="text-lg text-white/80 mb-8">
          Only $2.50/month for the first year.
        </p>

        {/* CTA Button */}
        <div className="flex flex-col items-center gap-4">
          <Link 
            to="/payment"
            className="btn-adsmash-primary text-white px-12 py-5 rounded-md font-semibold text-lg transition-all shadow-lg inline-block"
          >
            Get it now - $3/month
          </Link>
          <p className="text-white/70 text-sm">
            30-Day Money Back Guarantee.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Pricing;

